// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"cookieBanner-module--wrapper--3nkf2","buttonWrapper":"cookieBanner-module--buttonWrapper--1rCTl","content":"cookieBanner-module--content--1UkmM"};